import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/passwords', { params });
  },
  createData() {
    return Backend.get('/passwords/create');
  },
  editData(id) {
    return Backend.get(`/passwords/${id}/edit`);
  },
  create(data) {
    return Backend.post('/passwords', data);
  },
  update(data) {
    return Backend.put(`/passwords/${data.id}`, data);
  },
  delete(id) {
    return Backend.delete(`/passwords/${id}`);
  },
};
